<div class="app-page" style="padding: 16px;">
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </button>
    <span style="font-weight: 600;">APP COLORS</span>
    <span class="spacer"></span>
    <button mat-button type="button" (click)="resetToDefaults()">DEFAULTS</button>
    <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="appColorsForm.invalid">SAVE</button>
  </mat-toolbar>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <form [formGroup]="appColorsForm" class="app-colors-grid">
    <mat-card appearance="outlined" class="palette-card" [formGroup]="appColorsForm.controls.light">
      <div class="palette-title">{{ lightPaletteLabel }}</div>

      @for (key of paletteKeys; track key) {
        <div class="color-row">
          <label class="color-label">{{ getColorLabel(key) }}</label>
          <input type="color" [formControl]="getColorControl('light', key)" class="color-picker" />
          <mat-form-field appearance="outline" class="color-input">
            <input matInput [formControl]="getColorControl('light', key)" />
          </mat-form-field>
        </div>
      }
    </mat-card>

    <mat-card appearance="outlined" class="palette-card" [formGroup]="appColorsForm.controls.dark">
      <div class="palette-title">{{ darkPaletteLabel }}</div>

      @for (key of paletteKeys; track key) {
        <div class="color-row">
          <label class="color-label">{{ getColorLabel(key) }}</label>
          <input type="color" [formControl]="getColorControl('dark', key)" class="color-picker" />
          <mat-form-field appearance="outline" class="color-input">
            <input matInput [formControl]="getColorControl('dark', key)" />
          </mat-form-field>
        </div>
      }
    </mat-card>
  </form>

 <!--  <mat-card appearance="outlined" class="json-preview-card">
    <div class="palette-title">Stored JSON value (AppColors)</div>
    <pre>{{ getPreviewJson() }}</pre>
  </mat-card> -->
</div>
